export default __webpack_public_path__ + "static/media/RCSP_BRONZE.80f62623.jpg";